var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBattery = function SvgBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 64h-32V16c0-8.832-7.168-16-16-16h-96c-8.832 0-16 7.168-16 16v48h-32c-17.632 0-32 14.368-32 32v384c0 17.952 14.048 32 32 32h192c17.952 0 32-14.048 32-32V96c0-17.952-14.048-32-32-32m-96 352v-96h-64l64-160v96h64z"
  })));
};
export default SvgBattery;